import * as Mutations from './mutation-types'
import MaterialUtils from "@/core/utils/material-utils";

export default {
  [Mutations.LOAD_CONTENT_TIME](state, contentTime) {
    return state.totalContentTime = contentTime.map(content => ({
      materialId: content.tipo_conteudo,
      time: content.tempo
    }))
  },

  [Mutations.LOAD_DISCIPLINES](state, data) {
    let courses = []
    let modules = []

    const disciplines = data.map(discipline => {
      discipline.cursos.forEach(course => {
        course.modulos.forEach(module => {
          const moduleData = {
            id: module.id,
            name: module.modulo,
            courseId: course.id
          }

          modules.push(moduleData)
        })

        const courseData = {
          id: course.id,
          name: course.curso,
          disciplineId: discipline.id,
        }

        courses.push(courseData)
      })

      return {id: discipline.id, name: discipline.disciplina}
    })

    state.modules = modules
    state.courses = courses

    return state.disciplines = disciplines
  },

  [Mutations.LOAD_EDITABLE_SCHEDULE_CONFIG](state, scheduleConfig) {
    let {
      cor,
      data_inicio,
      data_fim,
      cursos_ids,
      dias_da_semana,
      disciplinas_ids,
      modulos_ids,
      tempo_diario_estudo
    } = scheduleConfig

    dias_da_semana = JSON.parse(dias_da_semana)

    return state.scheduleConfig = {
      ...state.scheduleConfig,
      cor,
      data_inicio,
      data_fim,
      cursos_ids,
      dias_da_semana,
      disciplinas_ids,
      modulos_ids,
      tempo_diario_estudo
    }
  },

  [Mutations.LOAD_STUDY_MATERIALS](state, materials) {

    return state.studyMaterials = materials.map(material => {
      const {icon} = MaterialUtils.recoverMaterialType(material.id)

      return {id: material.id, name: material.descricao, icon}
    })
  },

  [Mutations.RESET_SCHEDULE_CONFIG](state) {
    return state.scheduleConfig = {
      cor: null,
      cursos_ids: [],
      data_inicio: null,
      data_fim: null,
      dias_da_semana: [1, 2, 3, 4, 5],
      disciplinas_ids: [],
      id: null,
      materiais_estudo_agenda: [1, 2, 3, 4, 5, 6, 7],
      modulos_ids: [],
      tempo_diario_estudo: 0,
    }
  },

  [Mutations.SET_API_ERRORS](state, errors) {
    return state.apiErrors = errors
  },

  [Mutations.SET_CREATION_STEP](state, step) {
    return state.creationStep = step
  },

  [Mutations.SET_IS_UPDATE](state, status) {
    return state.isUpdate = status
  },

  [Mutations.SET_SCHEDULE_COLOR](state, color) {
    return state.scheduleConfig.cor = color
  },

  [Mutations.SET_SCHEDULE_COURSES](state, courses) {
    return state.scheduleConfig.cursos_ids = courses.map(course => course.id)
  },

  [Mutations.SET_SCHEDULE_DAILY_STUDY_TIME](state, time) {
    return state.scheduleConfig.tempo_diario_estudo = time
  },

  [Mutations.SET_SCHEDULE_DATES](state, dateRange) {
    const scheduleConfig = state.scheduleConfig
    scheduleConfig.data_inicio = dateRange[0]
    scheduleConfig.data_fim = dateRange[1]

    return state.scheduleConfig = scheduleConfig
  },

  [Mutations.SET_SCHEDULE_DISCIPLINES](state, disciplines) {
    const scheduleDisciplines = disciplines.map(discipline => discipline.id)

    state.scheduleConfig.cursos_ids = state.courses.filter(course => {
      return scheduleDisciplines.includes(course.disciplineId) && state.scheduleConfig.cursos_ids.includes(course.id)
    }).map(course => course.id)

    return state.scheduleConfig.disciplinas_ids = scheduleDisciplines
  },

  [Mutations.SET_SCHEDULE_ID](state, id) {
    return state.scheduleConfig.id = id
  },

  [Mutations.SET_SCHEDULE_MATERIALS](state, materialsIds) {
    return state.scheduleConfig.materiais_estudo_agenda = materialsIds
  },

  [Mutations.SET_SCHEDULE_MODULES](state, modulesIds) {
    return state.scheduleConfig.modulos_ids = modulesIds
  },

  [Mutations.SET_SCHEDULE_WEEKDAYS](state, weekdays) {
    return state.scheduleConfig.dias_da_semana = weekdays
  }
}
